import { defineStore } from "pinia"
import { computed, ref } from "vue"
import { useCartStore } from "./CartStore"
import { useEventStore } from "./EventStore"
import { useTicketTypeStore } from "./TicketTypeStore"
import { useUserStore } from "./UserStore"
import * as Sentry from "@sentry/browser";
import axios from "@/tools/Axios/axios";

export const useAppStore = defineStore('AppStore', () => {

    const cartStore = useCartStore()
    const eventStore = useEventStore()
    const userStore = useUserStore()
    const ticketTypeStore = useTicketTypeStore()

    /**
     * Modal ID
     */
    const closeUserSessionModalId = Symbol('closeUserSessionModalId')
    const pauseUserSessionModalId = Symbol('pauseUserSessionModalId')

    /**
     * STATE
     */
    const isLoading = ref(false)
    const menuIsOpen = ref(false)
    const cartIsOpen = ref(false)

    /**
     * ACTIONS
     */
    const logout = () => {
        userStore.logOut()
        eventStore.$reset()
        cartStore.$reset()
        ticketTypeStore.$reset()
    }

    const closeUserSession = async () => {
        await userStore.closeSession()
        logout()
    }

    const isApiOk = async () => {
        try {
            const response = await axios.get<{ status: "ok" | "error", message: string }>("/healthcheck")
            if (response.data.status === "error") {
                return false
            }
        } catch (err) {
            return false
        }
        return true
    }

    /**
     * SUBSCRIBERS
     */
    cartStore.$subscribe((mutation, state) => {
        const events = mutation.events
        if (events) {
            if (!Array.isArray(events['key'])) {
                if (events['key'] && events['key'] !== 'currentStock') {
                    eventStore.updateStock(state)
                    ticketTypeStore.updateCurrentStock(state)
                }
            }
        }
    })

    eventStore.$subscribe((mutation, state) => {
        const events = mutation.events
        if (events) {
            if (!Array.isArray(events['key'])) {
                if (events['key'] && events['key'] == 'currentEvent') {
                    Sentry.setContext('AppEvent', {
                        id: state.currentEvent?._id,
                        name: state.currentEvent?.name
                    })
                }
                if (events['key'] && events['key'] == 'currentSession') {
                    Sentry.setContext('AppEventSession', {
                        id: state.currentSession?._id,
                        date: state.currentSession?.date
                    })
                }
            }
        }
    })


    return {
        isLoading,
        menuIsOpen,
        cartIsOpen,
        logout,
        closeUserSession,
        closeUserSessionModalId,
        pauseUserSessionModalId,
        isApiOk
    }

  })
